import { render, staticRenderFns } from "./assign-user-groups.vue?vue&type=template&id=5c55f946&scoped=true"
import script from "./assign-user-groups.vue?vue&type=script&lang=js"
export * from "./assign-user-groups.vue?vue&type=script&lang=js"
import style0 from "./assign-user-groups.vue?vue&type=style&index=0&id=5c55f946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55f946",
  null
  
)

export default component.exports